import React from "react";
import { BaseButtons } from "../../../../common-components";
import { colors } from "../../../../../themes/Colors";

const NotificationCard = ({
  title,
  description,
  status,
  onAcceptClick,
  onDeclineClick,
}) => {
  return (
    <div
      style={{
        width: "100%",
        height: 200,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          borderRadius: 10,
          backgroundColor: colors.white,
          height: "85%",
          width: "90%",
          WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
          alignItems: "center",
        }}
      >
        <div style={{ width: "100%", marginBottom: 10 }}>
          <div style={{ marginLeft: 25, marginTop: 15, fontWeight: "bold" }}>
            {title}
          </div>
        </div>
        <div
          style={{
            flex: 1,
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "auto",
            flexDirection: "column",
          }}
        >
          <div style={{ width: "80%", fontSize: 14 }}>{description}</div>
        </div>

        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginBottom: 15,
          }}
        >
          {status === "Pending" ? (
            <>
              <BaseButtons
                label={"DECLINE"}
                borderRadius={8}
                backgroundColor={colors.orangeDark}
                height={35}
                width={130}
                onClick={onDeclineClick}
              />
              <BaseButtons
                label={"ACCEPT"}
                borderRadius={8}
                backgroundColor={colors.greenLight}
                height={35}
                width={130}
                onClick={onAcceptClick}
              />
            </>
          ) : (
            <BaseButtons
              label={status}
              borderRadius={8}
              backgroundColor={
                status === "ACCEPTED" ? colors.greenLight : colors.orangeDark
              }
              height={35}
              width={"90%"}
              onClick={null}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationCard;
